module.exports = __webpack_public_path__ + "static/media/team-Ju.fbe97c77.png";